import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressReportsSideMenuComponent } from '../progress-reports-side-menu/progress-reports-side-menu.component';

@Component({
  selector: 'app-progress-reports',
  imports: [TranslateModule, RouterOutlet, ProgressReportsSideMenuComponent],
  templateUrl: './progress-reports.component.html',
  styleUrl: './progress-reports.component.scss',
})
export class ProgressReportsComponent {
  constructor() {}
}
